<template>
  <div class="m-1">
    <Input
      :label="$t('link')"
      :value="options.href"
      @enter="propChanged('href', $event)"
      @blur="propChanged('href', $event)"
    />
    <br />
    <span>{{ $t('width') }}</span>
    <SpacementInput :value="options.width" @change="propChanged('width', $event)" />
    <br />
    <span>{{ $t('height') }}</span>
    <SpacementInput :value="options.height" @change="propChanged('height', $event)" />
    <br />
  </div>
</template>

<script>
import WidgetSideNavMixin from './Mixin.js'

export default {
  name: 'IframeSideNav',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.panel.widget.iframe-side-nav' },
  components: { SpacementInput: () => import('@/components/sidenav/shared/SpacementInput') },
  mixins: [WidgetSideNavMixin],
}
</script>
